/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateBulkUploadHistoryRecordeRequest,
    CreateOrderRequest,
    CustomTokenDto,
    GenerateCustomTokenRequest,
    LocationsDto,
    OneTimeUUIDDto,
    OneTimeUUIDRequestDto,
    PatchShopifyStoreRequest,
    QueryProductsByHandleResponseDto,
    QueryProductsResponseDto,
    SetupLocationIdRequestDto,
    SetupProductRequestDto,
    ShoifyStoresDto,
    ShoifyStoresWebhooksConfigStatusResponse,
    StoreListingItem,
    ValidationStoreDto,
} from '../models';

export interface ShopifyApiControllerBulkUploadHistoryRequest {
    sellerId: string;
    shopifyStoreId: string;
    createBulkUploadHistoryRecordeRequest: CreateBulkUploadHistoryRecordeRequest;
}

export interface ShopifyApiControllerConfigureFulfillmentsWebhooksRequest {
    sellerId: string;
    shopifyStoreId: string;
}

export interface ShopifyApiControllerConfigureProductsUpdateWebhookRequest {
    sellerId: string;
    shopifyStoreId: string;
}

export interface ShopifyApiControllerConfigureWebhooksRequest {
    sellerId: string;
    shopifyStoreId: string;
}

export interface ShopifyApiControllerEditLocationIdRequest {
    sellerId: string;
    shopifyStoreId: string;
    setupLocationIdRequestDto: SetupLocationIdRequestDto;
}

export interface ShopifyApiControllerEditProductRequest {
    sellerId: string;
    shopifyStoreId: string;
    inventoryLevelId: string;
    setupProductRequestDto: SetupProductRequestDto;
}

export interface ShopifyApiControllerGenerateCustomTokenRequest {
    generateCustomTokenRequest: GenerateCustomTokenRequest;
}

export interface ShopifyApiControllerGenerateOneTimeUUIDRequest {
    sellerId: string;
    oneTimeUUIDRequestDto: OneTimeUUIDRequestDto;
}

export interface ShopifyApiControllerIsWebhooksConfiguredRequest {
    sellerId: string;
    shopifyStoreId: string;
}

export interface ShopifyApiControllerPatchShopifyStoreRequest {
    sellerId: string;
    shopifyStoreId: string;
    patchShopifyStoreRequest: PatchShopifyStoreRequest;
}

export interface ShopifyApiControllerQueryLocationsRequest {
    sellerId: string;
    shopifyStoreId: string;
}

export interface ShopifyApiControllerQueryProductRequest {
    sellerId: string;
    shopifyStoreId: string;
    productId: string;
}

export interface ShopifyApiControllerQueryProductsRequest {
    sellerId: string;
    shopifyStoreId: string;
    first?: number;
    after?: string;
    query?: string;
}

export interface ShopifyApiControllerQueryProductsByHandleRequest {
    sellerId: string;
    shopifyStoreId: string;
    handle: string;
}

export interface ShopifyApiControllerQueryStoresRequest {
    sellerId: string;
}

export interface ShopifyApiControllerRemoveAccessTokenRequest {
    sellerId: string;
    shopifyStoreId: string;
}

export interface ShopifyApiControllerRemoveFulfillmentsWebhooksRequest {
    sellerId: string;
    shopifyStoreId: string;
}

export interface ShopifyApiControllerRemoveProductsUpdateWebhookRequest {
    sellerId: string;
    shopifyStoreId: string;
}

export interface ShopifyApiControllerRemoveWebhooksConfiguresRequest {
    sellerId: string;
    shopifyStoreId: string;
}

export interface ShopifyApiControllerSyncOrderRequest {
    sellerId: string;
    masterOrderId: string;
}

export interface ShopifyApiControllerSyncOrdersRequest {
    sellerId: string;
    createOrderRequest: CreateOrderRequest;
}

export interface ShopifyApiControllerValidateStoreRequest {
    sellerId: string;
    shopifyStoreId: string;
}

/**
 * 
 */
export class ShopifyApi extends runtime.BaseAPI {

    /**
     */
    async shopifyApiControllerBulkUploadHistoryRaw(requestParameters: ShopifyApiControllerBulkUploadHistoryRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerBulkUploadHistory.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerBulkUploadHistory.');
        }

        if (requestParameters.createBulkUploadHistoryRecordeRequest === null || requestParameters.createBulkUploadHistoryRecordeRequest === undefined) {
            throw new runtime.RequiredError('createBulkUploadHistoryRecordeRequest','Required parameter requestParameters.createBulkUploadHistoryRecordeRequest was null or undefined when calling shopifyApiControllerBulkUploadHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/bulk-upload-histories`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createBulkUploadHistoryRecordeRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerBulkUploadHistory(requestParameters: ShopifyApiControllerBulkUploadHistoryRequest): Promise<void> {
        await this.shopifyApiControllerBulkUploadHistoryRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerConfigureFulfillmentsWebhooksRaw(requestParameters: ShopifyApiControllerConfigureFulfillmentsWebhooksRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerConfigureFulfillmentsWebhooks.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerConfigureFulfillmentsWebhooks.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/webhooks/fulfillments`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerConfigureFulfillmentsWebhooks(requestParameters: ShopifyApiControllerConfigureFulfillmentsWebhooksRequest): Promise<void> {
        await this.shopifyApiControllerConfigureFulfillmentsWebhooksRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerConfigureProductsUpdateWebhookRaw(requestParameters: ShopifyApiControllerConfigureProductsUpdateWebhookRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerConfigureProductsUpdateWebhook.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerConfigureProductsUpdateWebhook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/webhooks/products-update`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerConfigureProductsUpdateWebhook(requestParameters: ShopifyApiControllerConfigureProductsUpdateWebhookRequest): Promise<void> {
        await this.shopifyApiControllerConfigureProductsUpdateWebhookRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerConfigureWebhooksRaw(requestParameters: ShopifyApiControllerConfigureWebhooksRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerConfigureWebhooks.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerConfigureWebhooks.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/webhooks`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerConfigureWebhooks(requestParameters: ShopifyApiControllerConfigureWebhooksRequest): Promise<void> {
        await this.shopifyApiControllerConfigureWebhooksRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerEditLocationIdRaw(requestParameters: ShopifyApiControllerEditLocationIdRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerEditLocationId.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerEditLocationId.');
        }

        if (requestParameters.setupLocationIdRequestDto === null || requestParameters.setupLocationIdRequestDto === undefined) {
            throw new runtime.RequiredError('setupLocationIdRequestDto','Required parameter requestParameters.setupLocationIdRequestDto was null or undefined when calling shopifyApiControllerEditLocationId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setupLocationIdRequestDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerEditLocationId(requestParameters: ShopifyApiControllerEditLocationIdRequest): Promise<void> {
        await this.shopifyApiControllerEditLocationIdRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerEditProductRaw(requestParameters: ShopifyApiControllerEditProductRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerEditProduct.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerEditProduct.');
        }

        if (requestParameters.inventoryLevelId === null || requestParameters.inventoryLevelId === undefined) {
            throw new runtime.RequiredError('inventoryLevelId','Required parameter requestParameters.inventoryLevelId was null or undefined when calling shopifyApiControllerEditProduct.');
        }

        if (requestParameters.setupProductRequestDto === null || requestParameters.setupProductRequestDto === undefined) {
            throw new runtime.RequiredError('setupProductRequestDto','Required parameter requestParameters.setupProductRequestDto was null or undefined when calling shopifyApiControllerEditProduct.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/inventories/{inventoryLevelId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))).replace(`{${"inventoryLevelId"}}`, encodeURIComponent(String(requestParameters.inventoryLevelId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setupProductRequestDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerEditProduct(requestParameters: ShopifyApiControllerEditProductRequest): Promise<void> {
        await this.shopifyApiControllerEditProductRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerGenerateCustomTokenRaw(requestParameters: ShopifyApiControllerGenerateCustomTokenRequest): Promise<runtime.ApiResponse<CustomTokenDto>> {
        if (requestParameters.generateCustomTokenRequest === null || requestParameters.generateCustomTokenRequest === undefined) {
            throw new runtime.RequiredError('generateCustomTokenRequest','Required parameter requestParameters.generateCustomTokenRequest was null or undefined when calling shopifyApiControllerGenerateCustomToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/shopify:generate-custom-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.generateCustomTokenRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerGenerateCustomToken(requestParameters: ShopifyApiControllerGenerateCustomTokenRequest): Promise<CustomTokenDto> {
        const response = await this.shopifyApiControllerGenerateCustomTokenRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shopifyApiControllerGenerateOneTimeUUIDRaw(requestParameters: ShopifyApiControllerGenerateOneTimeUUIDRequest): Promise<runtime.ApiResponse<OneTimeUUIDDto>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerGenerateOneTimeUUID.');
        }

        if (requestParameters.oneTimeUUIDRequestDto === null || requestParameters.oneTimeUUIDRequestDto === undefined) {
            throw new runtime.RequiredError('oneTimeUUIDRequestDto','Required parameter requestParameters.oneTimeUUIDRequestDto was null or undefined when calling shopifyApiControllerGenerateOneTimeUUID.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify:generate-uuid`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.oneTimeUUIDRequestDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerGenerateOneTimeUUID(requestParameters: ShopifyApiControllerGenerateOneTimeUUIDRequest): Promise<OneTimeUUIDDto> {
        const response = await this.shopifyApiControllerGenerateOneTimeUUIDRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shopifyApiControllerIsWebhooksConfiguredRaw(requestParameters: ShopifyApiControllerIsWebhooksConfiguredRequest): Promise<runtime.ApiResponse<ShoifyStoresWebhooksConfigStatusResponse>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerIsWebhooksConfigured.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerIsWebhooksConfigured.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/webhooks:config-status`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerIsWebhooksConfigured(requestParameters: ShopifyApiControllerIsWebhooksConfiguredRequest): Promise<ShoifyStoresWebhooksConfigStatusResponse> {
        const response = await this.shopifyApiControllerIsWebhooksConfiguredRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shopifyApiControllerPatchShopifyStoreRaw(requestParameters: ShopifyApiControllerPatchShopifyStoreRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerPatchShopifyStore.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerPatchShopifyStore.');
        }

        if (requestParameters.patchShopifyStoreRequest === null || requestParameters.patchShopifyStoreRequest === undefined) {
            throw new runtime.RequiredError('patchShopifyStoreRequest','Required parameter requestParameters.patchShopifyStoreRequest was null or undefined when calling shopifyApiControllerPatchShopifyStore.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchShopifyStoreRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerPatchShopifyStore(requestParameters: ShopifyApiControllerPatchShopifyStoreRequest): Promise<void> {
        await this.shopifyApiControllerPatchShopifyStoreRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerQueryLocationsRaw(requestParameters: ShopifyApiControllerQueryLocationsRequest): Promise<runtime.ApiResponse<LocationsDto>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerQueryLocations.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerQueryLocations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/locations`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerQueryLocations(requestParameters: ShopifyApiControllerQueryLocationsRequest): Promise<LocationsDto> {
        const response = await this.shopifyApiControllerQueryLocationsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shopifyApiControllerQueryProductRaw(requestParameters: ShopifyApiControllerQueryProductRequest): Promise<runtime.ApiResponse<StoreListingItem>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerQueryProduct.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerQueryProduct.');
        }

        if (requestParameters.productId === null || requestParameters.productId === undefined) {
            throw new runtime.RequiredError('productId','Required parameter requestParameters.productId was null or undefined when calling shopifyApiControllerQueryProduct.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/products/{productId}`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))).replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters.productId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerQueryProduct(requestParameters: ShopifyApiControllerQueryProductRequest): Promise<StoreListingItem> {
        const response = await this.shopifyApiControllerQueryProductRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shopifyApiControllerQueryProductsRaw(requestParameters: ShopifyApiControllerQueryProductsRequest): Promise<runtime.ApiResponse<QueryProductsResponseDto>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerQueryProducts.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerQueryProducts.');
        }

        const queryParameters: any = {};

        if (requestParameters.first !== undefined) {
            queryParameters['first'] = requestParameters.first;
        }

        if (requestParameters.after !== undefined) {
            queryParameters['after'] = requestParameters.after;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/products`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerQueryProducts(requestParameters: ShopifyApiControllerQueryProductsRequest): Promise<QueryProductsResponseDto> {
        const response = await this.shopifyApiControllerQueryProductsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shopifyApiControllerQueryProductsByHandleRaw(requestParameters: ShopifyApiControllerQueryProductsByHandleRequest): Promise<runtime.ApiResponse<QueryProductsByHandleResponseDto>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerQueryProductsByHandle.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerQueryProductsByHandle.');
        }

        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling shopifyApiControllerQueryProductsByHandle.');
        }

        const queryParameters: any = {};

        if (requestParameters.handle !== undefined) {
            queryParameters['handle'] = requestParameters.handle;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/stores/{sellerId}/shopify/{shopifyStoreId}/products`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerQueryProductsByHandle(requestParameters: ShopifyApiControllerQueryProductsByHandleRequest): Promise<QueryProductsByHandleResponseDto> {
        const response = await this.shopifyApiControllerQueryProductsByHandleRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shopifyApiControllerQueryStoresRaw(requestParameters: ShopifyApiControllerQueryStoresRequest): Promise<runtime.ApiResponse<ShoifyStoresDto>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerQueryStores.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/stores`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerQueryStores(requestParameters: ShopifyApiControllerQueryStoresRequest): Promise<ShoifyStoresDto> {
        const response = await this.shopifyApiControllerQueryStoresRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shopifyApiControllerRemoveAccessTokenRaw(requestParameters: ShopifyApiControllerRemoveAccessTokenRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerRemoveAccessToken.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerRemoveAccessToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}:remove-access-token`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerRemoveAccessToken(requestParameters: ShopifyApiControllerRemoveAccessTokenRequest): Promise<void> {
        await this.shopifyApiControllerRemoveAccessTokenRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerRemoveFulfillmentsWebhooksRaw(requestParameters: ShopifyApiControllerRemoveFulfillmentsWebhooksRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerRemoveFulfillmentsWebhooks.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerRemoveFulfillmentsWebhooks.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/webhooks/fulfillments`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerRemoveFulfillmentsWebhooks(requestParameters: ShopifyApiControllerRemoveFulfillmentsWebhooksRequest): Promise<void> {
        await this.shopifyApiControllerRemoveFulfillmentsWebhooksRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerRemoveProductsUpdateWebhookRaw(requestParameters: ShopifyApiControllerRemoveProductsUpdateWebhookRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerRemoveProductsUpdateWebhook.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerRemoveProductsUpdateWebhook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/webhooks/products-update`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerRemoveProductsUpdateWebhook(requestParameters: ShopifyApiControllerRemoveProductsUpdateWebhookRequest): Promise<void> {
        await this.shopifyApiControllerRemoveProductsUpdateWebhookRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerRemoveWebhooksConfiguresRaw(requestParameters: ShopifyApiControllerRemoveWebhooksConfiguresRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerRemoveWebhooksConfigures.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerRemoveWebhooksConfigures.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}/webhooks`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerRemoveWebhooksConfigures(requestParameters: ShopifyApiControllerRemoveWebhooksConfiguresRequest): Promise<void> {
        await this.shopifyApiControllerRemoveWebhooksConfiguresRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerSetupAccessTokenRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/shopify:setup-access-token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerSetupAccessToken(): Promise<void> {
        await this.shopifyApiControllerSetupAccessTokenRaw();
    }

    /**
     */
    async shopifyApiControllerSyncOrderRaw(requestParameters: ShopifyApiControllerSyncOrderRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerSyncOrder.');
        }

        if (requestParameters.masterOrderId === null || requestParameters.masterOrderId === undefined) {
            throw new runtime.RequiredError('masterOrderId','Required parameter requestParameters.masterOrderId was null or undefined when calling shopifyApiControllerSyncOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/orders/{masterOrderId}:sync-to-shopify`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"masterOrderId"}}`, encodeURIComponent(String(requestParameters.masterOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerSyncOrder(requestParameters: ShopifyApiControllerSyncOrderRequest): Promise<void> {
        await this.shopifyApiControllerSyncOrderRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerSyncOrdersRaw(requestParameters: ShopifyApiControllerSyncOrdersRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerSyncOrders.');
        }

        if (requestParameters.createOrderRequest === null || requestParameters.createOrderRequest === undefined) {
            throw new runtime.RequiredError('createOrderRequest','Required parameter requestParameters.createOrderRequest was null or undefined when calling shopifyApiControllerSyncOrders.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/orders:sync-to-shopify`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createOrderRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerSyncOrders(requestParameters: ShopifyApiControllerSyncOrdersRequest): Promise<void> {
        await this.shopifyApiControllerSyncOrdersRaw(requestParameters);
    }

    /**
     */
    async shopifyApiControllerValidateStoreRaw(requestParameters: ShopifyApiControllerValidateStoreRequest): Promise<runtime.ApiResponse<ValidationStoreDto>> {
        if (requestParameters.sellerId === null || requestParameters.sellerId === undefined) {
            throw new runtime.RequiredError('sellerId','Required parameter requestParameters.sellerId was null or undefined when calling shopifyApiControllerValidateStore.');
        }

        if (requestParameters.shopifyStoreId === null || requestParameters.shopifyStoreId === undefined) {
            throw new runtime.RequiredError('shopifyStoreId','Required parameter requestParameters.shopifyStoreId was null or undefined when calling shopifyApiControllerValidateStore.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{sellerId}/shopify/{shopifyStoreId}:validate`.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters.sellerId))).replace(`{${"shopifyStoreId"}}`, encodeURIComponent(String(requestParameters.shopifyStoreId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shopifyApiControllerValidateStore(requestParameters: ShopifyApiControllerValidateStoreRequest): Promise<ValidationStoreDto> {
        const response = await this.shopifyApiControllerValidateStoreRaw(requestParameters);
        return await response.value();
    }

}
